import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";
import axios from "axios";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import RosterPage from "@/pages/RosterPage";
import EventsPage from "@/pages/EventsPage";
import AboutPage from "@/pages/AboutPage";
import MerchPage from "@/pages/MerchPage";
import ContactPage from "@/pages/ContactPage";
import ChampionshipsPage from "@/pages/ChampionshipsPage";
import NewsPage from "@/pages/NewsPage";
import SponsorsPage from "@/pages/SponsorsPage";
import GalleryPage from "@/pages/GalleryPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  useEffect(() => {
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/track`).catch(() => {});
  }, []);

  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#000000',
              color: '#EFE8D8',
              border: 'none',
              borderRadius: '0',
              fontFamily: '"Courier Prime", monospace',
            },
          }}
        />
        <Routes>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={
            <>
              <Navbar />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/locker-room" element={<RosterPage />} />
                  <Route path="/shows" element={<EventsPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/championships" element={<ChampionshipsPage />} />
                  <Route path="/dirt-sheets" element={<NewsPage />} />
                  <Route path="/merch" element={<MerchPage />} />
                  <Route path="/sponsors" element={<SponsorsPage />} />
                  <Route path="/gallery" element={<GalleryPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
